import { Skeleton } from "src/@/components/ui/skeleton";

const ChatInternoSkeletonHeader = () => {
  return (
    <div className="flex items-start p-4 h-20 bg-slate-100 rounded-lg flex-col gap-2">
      <Skeleton className="w-40 h-5" />
      <Skeleton className="w-20 h-5" />
    </div>
  );
};

export default ChatInternoSkeletonHeader;
